import { render, staticRenderFns } from "./TalentOff.vue?vue&type=template&id=46e581be&scoped=true&"
import script from "./TalentOff.vue?vue&type=script&lang=js&"
export * from "./TalentOff.vue?vue&type=script&lang=js&"
import style0 from "./TalentOff.vue?vue&type=style&index=0&id=46e581be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e581be",
  null
  
)

export default component.exports